import { makeAutoObservable } from 'mobx';
import SceneApiService from '../services/api/SceneApiService';
import { DataThird } from 'shared/models/dashboardModels/DataThird';
import { IGestureInfoDto, IGestureInfoDtoAdvance, IJointInfoDto } from '../shared/interfaces';
import { BoxPlotModel, DataGestureModel, DataGestureModel2, DataGestureModel3, DataProcessingModel, DataSecond, JointModel, } from '../shared/models/dashboardModels';
import authStore from './authStore';
import charactersStore from './charactersStore';

class DashboardStore {
    public dataLoader = new DataProcessingModel();
    public dataSecondLoader = new DataSecond();
    public dataThirdLoader = new DataThird();
    public GestureLoader = new DataGestureModel();
    public GestureLoader2 = new DataGestureModel2();
    public GestureLoader3 = new DataGestureModel3();
    public selectedJoint: JointModel | null = null;
    public selectedGesture: BoxPlotModel | null = null;
    public jointHand: 'left' | 'right' = 'left';
    public Switcher = false;
    public selectedGestureAdvanceSetting = true;
    public sizeRadarChartValue = 10;
    public Stats: any = null;
    public isLoading = false;
    public JointData: any = null;
    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    public setSelectedJoint(jointName: string, dto?: IJointInfoDto, dto2?: IJointInfoDto, dto3?: IJointInfoDto) {
        this.selectedJoint = new JointModel(jointName, dto, dto2, dto3);
    }
    public setStats(stat: number[] | null) {
        this.Stats = stat;
    }
    public setSelectedGesture(jointName: string, dto?: IGestureInfoDto[] | IGestureInfoDtoAdvance, dto2?: IGestureInfoDto[] | IGestureInfoDtoAdvance, dto3?: IGestureInfoDto[] | IGestureInfoDtoAdvance) {
        this.selectedGesture = new BoxPlotModel(jointName, dto, dto2, dto3);
    }
    public setJointUpdate(hand: 'left' | 'right') {
        this.jointHand = hand;
    }
    public setSizeRadarChartValue(value: number) {
        this.sizeRadarChartValue = value;
    }
    public setGestureAdvanceSetting(set: boolean) {
        this.selectedGestureAdvanceSetting = set;
    }
    public setSwitcher(switcher: boolean) {
        this.Switcher = switcher;
    }
    /**
     * 🔹 Получение данных для суставов персонажа по CSV дате
     */
    public async getJointData(levelName: string, joint: string, csvDate: string) {
        const char = charactersStore.selectedCharacter;
        if (!char)
            return;
        this.isLoading = true;
        try {
            const attempt = charactersStore.currentAttempt || 1;
            // Используем SceneApiService для запроса с токеном из localStorage
            const data = await SceneApiService.postCharacterSceneData(char.id, attempt, csvDate);
            this.JointData = data[joint] ?? null;
        }
        catch (error) {
            console.error('[DashboardStore] Error fetching joint data:', error);
            this.JointData = null;
        }
        finally {
            this.isLoading = false;
        }
    }
    public reset() {
        this.dataLoader = new DataProcessingModel();
        this.dataSecondLoader = new DataSecond();
        this.dataThirdLoader = new DataThird();
        this.GestureLoader = new DataGestureModel();
        this.GestureLoader2 = new DataGestureModel2();
        this.GestureLoader3 = new DataGestureModel3();
        this.selectedJoint = null;
        this.selectedGesture = null;
        this.jointHand = 'left';
        this.Switcher = false;
        this.selectedGestureAdvanceSetting = true;
        this.sizeRadarChartValue = 10;
        this.Stats = null;
        this.isLoading = false;
        this.JointData = null;
    }
    public clearSelectedJoint() {
        this.selectedJoint = null;
        this.selectedGesture = null;
        authStore.error = null;
    }
}
export default new DashboardStore();
